module.exports = require("lodash/min");